import React, { useState } from "react";
import Loader from "react-loader-spinner";
import { Formik, Form } from "formik";
import Info from "../../../../assets/info.svg";
import {
  ButtonGroup,
  StyledBankTransferFormButton,
  colors,
} from "../../../../../../Syles/styles";
import { BankTranferDetailsTextInput } from "./../../../../../Formik/BankDetailsInput";
import closemodalicon from "../../../../../../Assets/closemodalicon.svg";
import * as Yup from "yup";
import "./Information.css";
import { toast } from "react-toastify";
import { $api } from "../../../../../../../helpers/$api";

const NextOfKin = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleFormSubmit = async (values, { setSubmitting, setFieldError }) => {
    console.log(values);
    try {
      setSubmitting(true);
      await $api.user.addNextOfKin(values);
      toast.success("Next of kin added successfully");
    } catch (error) {
      if (error.isHttpException) {
        error.data.forEach(([key, message]) => {
          setFieldError(key, message);
        });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="information">
      <div>
        <img
          src={Info}
          alt="Info"
          className="info-image"
          onClick={() => setShowSuccess(true)}
        />
      </div>
      <p
        style={{
          fontSize: "1.5rem",
          marginLeft: "25px",
          fontWeight: "600",
        }}
      >
        Next of Kin
      </p>

      <div className="formSection">
        <Formik
          initialValues={{
            firstname: "",
            lastname: "",
            email: "",
            gender: "",
            phone: "",
            house_address: "",
            relationship: "",
          }}
          onSubmit={handleFormSubmit}
          validationSchema={Yup.object({
            firstname: Yup.string().required("Firstname is required"),
            lastname: Yup.string().required("Lastname is required"),
            // gender: Yup.string().required("Gender is required"),
            email: Yup.string().required("email is required"),
            phone: Yup.string().required("Phonenumber id required"),
            house_address: Yup.string().required("houseAddress is required"),
            relationship: Yup.string().required("relationship is required"),
          })}
        >
          {({ isSubmitting, values, handleChange }) => (
            <Form>
              <BankTranferDetailsTextInput
                name="firstname"
                type="tel"
                placeholder="Firstname"
              />

              <BankTranferDetailsTextInput
                name="lastname"
                type="tel"
                placeholder="Lastname"
              />
              <BankTranferDetailsTextInput
                name="email"
                type="tel"
                placeholder="Email"
              />
              <select
                name="gender"
                value={values.gender}
                id=""
                className="select-gender"
                onChange={handleChange}
                disabled={values.gender}
                style={{
                  outline: "none",
                }}
              >
                <option value=""> Select Gender</option>
                <option
                  value="male"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Male
                </option>
                <option
                  value="Female"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Female
                </option>
              </select>

              <BankTranferDetailsTextInput
                name="phone"
                type="tel"
                placeholder="Phonenumber"
              />
              <BankTranferDetailsTextInput
                name="house_address"
                type="tel"
                placeholder="Address"
              />
              <select
                name="relationship"
                value={values.relationship}
                id=""
                className="select-gender"
                onChange={handleChange}
                disabled={values.relationship}
                style={{
                  outline: "none",
                }}
              >
                <option value=""> Select Relationship</option>
                <option
                  value="male"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Parents
                </option>
                <option
                  value="Female"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Child
                </option>
                <option
                  value="Female"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Spouse
                </option>
                <option
                  value="Female"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Siblings
                </option>
                <option
                  value="Female"
                  style={{
                    fontSize: "1.15rem",
                  }}
                >
                  Others
                </option>
              </select>

              <ButtonGroup className="button-group">
                {!isSubmitting && (
                  <StyledBankTransferFormButton type="submit">
                    Save
                  </StyledBankTransferFormButton>
                )}

                {isSubmitting && (
                  <Loader
                    type="ThreeDots"
                    color={colors.primary}
                    height={49}
                    width={100}
                  />
                )}
              </ButtonGroup>
            </Form>
          )}
        </Formik>
      </div>

      <div
        className={`confirmbank__success-bg ${
          showSuccess ? "success-info" : ""
        }`}
      >
        <div className="confirm__success-content">
          <div className="confirm-close-modal">
            <button className="closemodal-btn">
              <img
                src={closemodalicon}
                alt=""
                className="closemodal"
                onClick={() => setShowSuccess(false)}
              />
            </button>
          </div>
          <div className="info-text">
            <h1>Kindly Note</h1>
            <p>
              Some details here can’t be edited. Contact hello@myovest.com to
              effect some changes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NextOfKin;
